import { Loader2, MoveLeft, MoveRight } from 'lucide-react';
import React from 'react';

interface PrevNextProps {
  onReset?: () => void;
  prev?: () => void;
  next?: () => void;
  hidePrevious?: boolean;
  create?: boolean;
  createLabel?: string;
  onCreate?: () => void;
  disableCreate?: boolean;
  disableNext?: boolean;
  disableReset?: boolean;
  onSaveDraft?: () => void;
  isEditMode?: boolean;
  isSubmitting?: boolean;
  isSavingDraft?: boolean;
}

export const PrevNext: React.FC<PrevNextProps> = ({
  onReset,
  prev,
  next,
  hidePrevious,
  create,
  createLabel = 'Create',
  onCreate,
  disableCreate = false,
  disableNext = false,
  disableReset = false,
  onSaveDraft,
  isEditMode = false,
  isSubmitting = false,
  isSavingDraft = false,
}) => {
  const handleReset = () => {
    if (onReset) onReset();
  };

  return (
    <div className="flex justify-between items-center mt-6">
      {/* Left Side → Previous or Reset if Previous is hidden */}
      {hidePrevious ? (
        <button
          type="button"
          onClick={handleReset}
          className="px-4 py-2 text-[#621C43] font-medium rounded-lg text-sm hover:bg-gray-100"
          disabled={isSubmitting}
        >
          {isEditMode ? 'Discard Changes' : 'Reset'}
        </button>
      ) : (
        prev && (
          <button
            type="button"
            onClick={prev}
            className="flex items-center gap-2 px-4 py-2 text-[#621C43] rounded-lg hover:bg-gray-100"
            disabled={isSubmitting}
          >
            <MoveLeft size={15} />
            Previous
          </button>
        )
      )}

      <div>
        {!hidePrevious && onReset && !disableReset && (
          <button
            type="button"
            onClick={handleReset}
            className="px-4 py-2 text-[#621C43] font-medium rounded-lg text-sm hover:bg-gray-100"
          >
            {isEditMode ? 'Discard Changes' : 'Reset'}
          </button>
        )}
      </div>
      {/* Right Side → Next/Create */}
      <div className="flex gap-3">
        {/* {!hidePrevious && (
          <button
            type="button"
            onClick={handleReset}
            className="px-4 py-2 border text-[#621C43] rounded-lg hover:bg-gray-100"
          >
            Reset
          </button>
        )} */}

        {onSaveDraft && (
          <button
            type="button"
            onClick={onSaveDraft}
            disabled={isSavingDraft || isSubmitting}
            className="px-6 py-2 bg-[#4C86E7] text-white rounded-lg hover:bg-[#4C86E7] flex items-center gap-2 disabled:opacity-70 disabled:cursor-not-allowed"
          >
            {isSavingDraft && <Loader2 size={16} className="animate-spin" />}
            {isSavingDraft ? 'Saving...' : 'Save as Draft'}
          </button>
        )}

        {create ? (
          <button
            type="button"
            onClick={onCreate}
            disabled={disableCreate || isSubmitting}
            className={`px-4 py-2 text-white text-sm rounded-lg flex items-center gap-2 ${
              disableCreate || isSubmitting
                ? 'bg-[#0CA96F] cursor-not-allowed'
                : 'bg-[#0CA96F] hover:bg-[#098356]'
            }`}
          >
            {isSubmitting && <Loader2 size={16} className="animate-spin" />}
            {createLabel}
          </button>
        ) : (
          next && (
            <button
              type="button"
              onClick={next}
              disabled={disableNext || isSubmitting}
              className={`px-6 flex items-center gap-2 py-2 rounded-lg transition-colors ${
                disableNext || isSubmitting
                  ? 'bg-blue-300 cursor-not-allowed text-white'
                  : 'bg-[#4C86E7] text-white hover:bg-[#4C86E7]'
              }`}
              title={disableNext ? 'Please fill in all required fields' : ''}
            >
              Next <MoveRight size={15} />
            </button>
          )
        )}
      </div>
    </div>
  );
};
